import { Badge } from "antd";
import React from "react";

export const projectStatusArray = [
  {
    value: "JUST ADDED",
    label: <Badge color="green" text="JUST ADDED" />
  },
  {
    value: "IN PROGRESS",
    label: <Badge color="red" text="IN PROGRESS" />
  },
  {
    value: "ISSUES",
    label: <Badge color="red" text="ISSUES" />
  },
  {
    value: "REJECTED",
    label: <Badge color="red" text="REJECTED" />
  },
  {
    value: "COMPLETED",
    label: <Badge color="green" text="COMPLETED" />
  },
  {
    value: "REVISION",
    label: <Badge color="yellow" text="REVISION" />
  }
];
